// extracted by mini-css-extract-plugin
export default {"logout-button":"logoutbutton_logout-button__OczzX","content":"logoutbutton_content__ab7EQ"};